module.exports = __webpack_public_path__ + "img/6.65be023c.png";